export const CreateSpaceRepository = Symbol('CreateSpaceRepository');
export const CreateSpaceService = Symbol('CreateSpaceService');
